<template>
    <div class="vb-field-editor-dash"
         @mouseleave="hover = false"
         @mouseover="readOnly ? hover = false : hover = true"
         :style="{display: display || 'flex'}">
        <v-icon class="vb-field-icon"
                v-if="icon">
            {{icon}}
        </v-icon>

        <div class="vb-field-info">
            <div class="vb-field-editor-dash__container">
                <div class="vb-field-editor-dash__title vb-field-editor-dash__input"
                     :data-ph="$t('general.titleNewInformation')"
                     contenteditable="true"
                     @keydown="activeActions()"
                     @keydown.enter.prevent="update()"
                     ref="titleEditor">{{value}}</div>
            </div>

            <div class="vb-field-editor-dash__container">
                <div class="vb-field-editor-dash__input"
                     :data-ph="placeholder"
                     contenteditable="true"
                     @keydown="activeActions()"
                     @keydown.enter.prevent="update()"
                     ref="fieldEditor">{{value}}</div>

                <transition name="fade">
                <span v-if="showActions || hover">
                    <span class="ml-3 green--text"
                          :class="[showActions ? 'feather-check-circle' : 'feather-edit-2']"
                          @click="update"
                          style="cursor: pointer"/>

                    <span class="feather-x mx-3 red--text"
                          @click="hideActions()"
                          style="cursor: pointer"
                          v-if="showActions"/>
                </span>
                </transition>
            </div>
        </div>
    </div>
</template>

<script>
export default {
  data: () => ({
    hover: false,
    showActions: false
  }),
  methods: {
    hideActions () {
      this.showActions = false
      this.$refs.fieldEditor.textContent = this.value
    },
    activeActions () {
      if (this.readOnly) return
      this.showActions = true
    },
    update () {
      if (this.readOnly) return

      if (!this.showActions) {
        this.activeActions()
        return
      }

      this.showActions = false
      this.$emit('update', { field: this.$refs.titleEditor.textContent, value: this.$refs.fieldEditor.textContent })
      this.$refs.titleEditor.textContent = ''
      this.$refs.fieldEditor.textContent = ''
    }
  },
  name: 'VBFieldEditor',
  props: {
    display: String,
    icon: String,
    placeholder: String,
    readOnly: Boolean,
    value: [String, Number]
  }
}
</script>

<style>
    .vb-field-editor-dash {
        margin-top: 10px;
    }

    .vb-field-icon {
        margin-right: 8px;
    }

    .vb-field-info {
        display: flex;
        flex-direction: column;
    }

    .vb-field-editor-dash__title {
        color: grey;
        font-size: 12px;
        font-weight: bold;
    }

    .vb-field-editor-dash__container {
        align-items: center;
        display: flex;
        padding-right: 10px;
    }

    .vb-field-editor-dash__input {
        word-break: break-word;
    }

    .vb-field-editor-dash__input:focus {
        outline: none;
    }

    .vb-field-editor-dash__container [contentEditable=true]:empty:before {
        content:attr(data-ph);
        color: rgba(0, 0, 0, .3);
        cursor: text;
    }

    .vb-field-editor-dash__container [contentEditable=false]:empty:before {
        content:attr(data-ph);
        color: rgba(0, 0, 0, .3);
        cursor: text;
    }

    .fade-enter-active,
    .fade-leave-active {
        transition: opacity .2s;
    }
    .fade-enter,
    .fade-leave-to
        /* .component-fade-leave-active below version 2.1.8 */ {
        opacity: 0;
    }
</style>
